import React, { forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import swal from "sweetalert";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import TapSelect from '../../../components/ui/TapSelect';
import TapHelper from '../../../services/TapHelper';
import DownloadFile from '../../../services/DownloadFile';
import TapNavTabs from '../../../components/ui/TapNavTabs';
import PageHeader from '../../includes/PageHeader';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import CommonOwnerShipCategorySearch from '../../assets/CommonOwnerShipCategorySearch';
import moment from 'moment';
import NumberFormatter from '../../../services/NumberFormater';
import { Helmet } from 'react-helmet';

const AssetWiseProductionCostingReport = forwardRef((props, ref) => {
    const access_token = useSelector(state => state.auth.access_token);
    const iam_asset_types = useSelector(state => state.app.asset_type);
    const iam_user_sites = useSelector(state => state.app.user_sites);
    const iam_asset_matrix = useSelector(state => state.app.asset_matrix);
    const iam_manufactures = useSelector(state => state.app.manufactures);
    const iam_models = useSelector(state => state.app.models);
    const asset_groups = useSelector(state => state.app.asset_groups);

    const REPORT_URL = `${IAM_API_BASE_URL_2}/report/asset_wise_production_cost_report`;
    const FORM_DATA_URL = IAM_API_BASE_URL_2 + '/report/asset-performance-matrix/form_data';

    const INIT_LIST_DATA = {
        loading: false,
        data_loaded: false,
        items: [],
        meta: null,
        page: 1,
        reset_filter: false,
        downloading: false,
        loading: false,
    };

    const INIT_FORM_DATA = {
        per_page: 50,
        site_group_ids: [],
        search_site_ids: [],
        asset_group_ids: [],
        search_asset_type_ids: [],
        search_asset_matrix_ids: [],
        search_manufacturer_ids: [],
        search_models: [],
        search_asset_ids: [],
        search_asset_type: [],
        search_ownership_category: "",
        search_owner_ids: [],
        search_owner_company: '',
        search_asset_category: '',
        date_range: 'current_month',
        date_range_start: moment().startOf('month').format('YYYY-MM-DD'),
        date_range_end: moment().endOf('month').format('YYYY-MM-DD'),
    };

    const FORM_DATA_LABELS = {
        search_site_ids: "Sites : ",
        asset_group_ids: "Asset Type Groups : ",
        search_asset_type_ids: "Asset Type : ",
        search_asset_matrix_ids: "Asset Matrix : ",
        search_manufacturer_ids: "Manufacturer : ",
        search_models: "Model : ",
        search_asset_ids: "Assets : ",
        search_asset_type: "Asset Type : ",
        site_group_ids: "Site Groups : ",
        search_ownership_category: "Ownership Category : ",
        search_owner_ids: "Owner : ",
        search_owner_company: "Owner Company : ",
        search_asset_category: 'Asset Category : ',
        date_range: 'Date Range :  ',
    };

    const [searchedAssets, setSearchedAssets] = useState([]);
    const [searchedCustomer, setSearchedCustomer] = useState(null);
    const [searchedVendor, setSearchedVendor] = useState(null);
    const [searchedElems, setSearchedElems] = useState([]);
    const [formData, setFormData] = useState({ ...INIT_FORM_DATA });
    const [assetCostingData, setAssetCostingData] = useState({ ...INIT_LIST_DATA });
    const [summaryData, setSummaryData] = useState({ data: null, loading: false });
    const [assetPerformanceFormData, setAssetPerformanceFormData] = useState({ periods: [], asset_category: [] });
    const [ownerData, setOwnerData] = useState({
        allOwnerCategoryList: [],
        allOwnersList: []
    });
    const [allSiteGroupsList, setAllSiteGroupsList] = useState([]);
    const [reportSubmitted, setReportSubmitted] = useState(false);
    const [filterShow, setFilterShow] = useState(false);
    const [criteriaHeight, setCriteriaHeight] = useState(0);
    const criteriaRef = useRef();

    const [searchModalId] = useState(uuid());
    const [currentTab, setCurrentTab] = useState(0);
    const searchModalRef = useRef(null);
    const ownershipRef = useRef();


    const transformedAssetTypes = iam_asset_types && iam_asset_types.map(at => ({ value: at.id, label: at.asset_type_name }));
    const transformedAssetMatrix = iam_asset_matrix && iam_asset_matrix.map(am => ({ value: am.id, label: am.asset_matrix_unique_id }));
    const transformedManufactures = iam_manufactures.map(m => ({ value: m.id, label: m.manufacturer_name }));
    const transformedModels = iam_models.map(m => ({ value: m.id, label: m.model_name }));
    const transformedUserSites = iam_user_sites.map(s => ({
        value: s.id,
        label: `${s.site_name} (${s.site_code})`
    }));
    const transformedAssetGroups = asset_groups && asset_groups.length > 0
        ? asset_groups.map(oc => ({
            value: oc.id,
            label: oc.name,
            linked_asset_types: oc.asset_type_ids
        }))
        : []

    useEffect(() => {
        initializeFormData();
    }, []);

    useEffect(() => {
        if (assetCostingData.reset_filter) {
            setAssetCostingData(prev => ({ ...prev, reset_filter: false }))
            loadSummaryData();
            loadItemsData(1);
        }
    }, [assetCostingData.reset_filter]);

    const applyFilters = (data, isInitial = false) => {
        setFormData(prev => ({ ...prev, ...data }));

        const elems = [];

        if (data.date_range) {
            const start = moment(data.date_range_start).format('DD-MMM-YYYY');
            const end = moment(data.date_range_end).format('DD-MMM-YYYY');

            elems.push(
                `Date Range : <b>${data.date_range} (${start} - ${end})</b>`
            );
        }

        Object.keys(FORM_DATA_LABELS).forEach(key => {
            if (key === 'date_range') return;
            const value = data[key];
            if (value && value.toString().length > 0) {
                elems.push(formatSearchLabel(key, value));
            }
        });

        setSearchedElems(elems);

        loadSummaryData(data);
        loadItemsData(1, data);
        setReportSubmitted(true); 
    };

    const initializeFormData = () => {
        HttpAPICall.withAthorization('GET', FORM_DATA_URL, access_token, null, null, (response) => {
            setAssetPerformanceFormData(response.data);
            setAllSiteGroupsList(
                response.data.site_groups && response.data.site_groups.length > 0
                    ? response.data.site_groups.map(oc => ({
                        value: oc.id,
                        label: oc.name,
                        linked_sites: oc.site_ids
                    }))
                    : []
            );

            const start = moment().startOf('month').format('YYYY-MM-DD');
            const end = moment().endOf('month').format('YYYY-MM-DD');

            applyFilters({
                date_range: 'current_month',
                date_range_start: start,
                date_range_end: end,
            }, true);
        })
        .catch(() => {
            const start = moment().startOf('month').format('YYYY-MM-DD');
            const end = moment().endOf('month').format('YYYY-MM-DD');

            applyFilters({
                date_range: 'current_month',
                date_range_start: start,
                date_range_end: end,
            }, true);
        });
    };
    const submitSearchFormHandler = (e) => {
        e.preventDefault();

        const searchedElems = [];
        const searchParams = {};
        if (formData.date_range) {
            searchParams.date_range = formData.date_range;
            searchParams.date_range_start = formData.date_range_start;
            searchParams.date_range_end = formData.date_range_end;

            searchedElems.push(
                formatSearchLabel('date_range', {
                    range: formData.date_range,
                    start: formData.date_range_start,
                    end: formData.date_range_end
                })
            );
        }

        Object.keys(FORM_DATA_LABELS).forEach(key => {
            if (key === 'date_range') return;

            const value = formData[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                searchedElems.push(formatSearchLabel(key, value));
            }
        });

        setSearchedElems(searchedElems);
        setFormData(prev => ({ ...prev, ...searchParams }));

        loadSummaryData(searchParams);
        loadItemsData(1, searchParams);
        setReportSubmitted(true);
        setFilterShow(false); 
    };

    const searchFormClear = () => {
        const start = moment().startOf('month').format('YYYY-MM-DD');
        const end = moment().endOf('month').format('YYYY-MM-DD');

        setFormData({
            ...INIT_FORM_DATA,
            date_range: 'current_month',
            date_range_start: start,
            date_range_end: end,
        });

        setSearchedAssets([]);
        setSearchedCustomer(null);
        setSearchedVendor(null);

        applyFilters({
            date_range: 'current_month',
            date_range_start: start,
            date_range_end: end,
        }, false);
    };

    const toggleFilterForm = (show) => {
        setFilterShow(show);
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    };

    const tapSelectChange = (selectedOption, fieldName) => {
        const data = Array.isArray(selectedOption)
            ? selectedOption.map(op => op.value)
            : selectedOption?.value || "";

        setFormData(prev => ({ ...prev, [fieldName]: data }));
    };

    const handleOwnerCategoryChange = (ownerCategoryData) => {
        setFormData(prev => ({ ...prev, ...ownerCategoryData }));
    };

    const handleOwnerDataLoad = (ownerData) => {
        setOwnerData({
            allOwnerCategoryList: ownerData.allOwnerCategoryList || [],
            allOwnersList: ownerData.allOwnersList || []
        });
        setSearchedCustomer(ownerData.searchedCustomer || []);
        setSearchedVendor(ownerData.searchedVendor || []);
    };

    const handleAssetGroupChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            asset_group_ids: selectedOption?.map(o => o.value) || [],
            search_asset_type_ids: selectedOption?.map(s => s.linked_asset_types).flat() || []
        }));
    };

    const handleSiteGroupChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            site_group_ids: selectedOption?.map(o => o.value) || [],
            search_site_ids: selectedOption?.map(s => s.linked_sites).flat() || []
        }));
    };

    const buildFilteredParams = (data) => {
        const params = {};

        Object.entries(data).forEach(([key, value]) => {
            if (
                value !== null &&
                value !== undefined &&
                value !== "" &&
                !(Array.isArray(value) && value.length === 0)
            ) {
                params[key] = value;
            }
        });

        return params;
    };

    const loadSummaryData = (searchParams = {}) => {
        setSummaryData(prev => ({ ...prev, loading: true }));

        const params = {
            action: 'consolidated',
            ...buildFilteredParams(formData),
            ...searchParams
        };

        HttpAPICall.withAthorization('GET', REPORT_URL, access_token, params, {})
            .then(response => {
                setSummaryData({
                    data: response.data,
                    loading: false
                });
            })
            .catch(() => {
                setSummaryData({ data: null, loading: false });
            });
    };

    const loadItemsData = (page = 1, searchParams = {}) => {
        setAssetCostingData(prev => ({
            ...prev,
            data_loaded: false,
            loading: true,
            page
        }));

        const params = {
            action: 'data',
            page,
            ...buildFilteredParams(formData),
            ...searchParams
        };


        HttpAPICall.withAthorization('GET', REPORT_URL, access_token, params, {})
            .then(response => {
                const respData = response.data;
                const meta = {
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page
                };

                setAssetCostingData(prev => ({
                    ...prev,
                    data_loaded: true,
                    loading: false,
                    items: respData.data || [],
                    meta
                }));
            })
            .catch(() => {
                setAssetCostingData(prev => ({
                    ...prev,
                    loading: false,
                    data_loaded: true,
                    items: [],
                    meta: null
                }));
            });
    };

    const reportDownloadHandler = () => {
        const params = {
            action: 'download',
            ...buildFilteredParams(formData)
        };

        setAssetCostingData(prev => ({ ...prev, downloading: true }));

        HttpAPICall.withAthorization('GET', REPORT_URL, access_token, params, {})
            .then(response => {
                DownloadFile.file(response.data.file_path, response.data.msg, response.data.navigation, props);
            })
            .finally(() => {
                setAssetCostingData(prev => ({ ...prev, downloading: false }));
            });
    };

    const formatSearchLabel = (key, value) => {
        const label = FORM_DATA_LABELS[key];
        let showVal = value;

        if (key === "date_range" && typeof value === 'object') {
            let start_range = moment(value.start).format('DD-MMM-YYYY');
            let end_range = moment(value.end).format('DD-MMM-YYYY');
            showVal = `${value.range} (${start_range} - ${end_range})`;
        } else if (key === "date_range" && typeof value === 'string') {
            let start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
            let end_range = moment(formData.date_range_end).format('DD-MMM-YYYY');
            showVal = `${value} (${start_range} - ${end_range})`;
        } else if (key === "search_asset_ids" && searchedAssets) {
            showVal = searchedAssets.map(s => s.display_label).join(', ');
        } else if (key === 'search_asset_category') {
            showVal = assetPerformanceFormData.asset_category?.filter((s) => value.includes(s.key)).map(s => s.name).join(', ') || value;
        } else if (key === "asset_group_ids") {
            showVal = transformedAssetGroups
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_asset_type_ids") {
            showVal = transformedAssetTypes
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_asset_matrix_ids") {
            showVal = transformedAssetMatrix
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_site_ids") {
            showVal = transformedUserSites
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "site_group_ids") {
            showVal = allSiteGroupsList
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_manufacturer_ids") {
            showVal = transformedManufactures
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_models") {
            showVal = transformedModels
                .filter(s => value.includes(s.value))
                .map(s => s.label)
                .join(", ");
        } else if (key === "search_ownership_category") {
            const category = ownerData.allOwnerCategoryList.find(oc => oc.value === value);
            showVal = category ? category.label : value;
        } else if (key === "search_owner_ids") {
            if (formData.search_ownership_category === "owned") {
                showVal = ownerData.allOwnersList
                    .filter(s => value.includes(s.value))
                    .map(s => s.label)
                    .join(', ');
            } else if (formData.search_ownership_category === "customer") {
                showVal = searchedCustomer?.map(s => s.display_label).join(', ') || value;
            } else if (formData.search_ownership_category === "vendor") {
                showVal = searchedVendor?.map(s => s.vendor?.name).join(', ') || value;
            }
        }

        return label + `<b>${showVal}</b>`;
    };

    const closeReport = () => {
        props.history.push('/report');
    };

    const reportFilterFormJsx = () => {
        const asset_category = assetPerformanceFormData?.asset_category
            ? assetPerformanceFormData.asset_category.map(ac => ({ value: ac.key, label: ac.name }))
            : [];

        return (
            <form onSubmit={submitSearchFormHandler} className='py-3'>
             
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Site Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={allSiteGroupsList}
                            changeEvent={handleSiteGroupChange}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={allSiteGroupsList.filter(s =>
                                formData.site_group_ids?.includes(s.value)
                            )}
                            placeholder="Select Site Group"
                        />
                    </div>
                </div>

                
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Site</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedUserSites}
                            changeEvent={(selectedOption) =>
                                tapSelectChange(selectedOption, "search_site_ids")
                            }
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedUserSites.filter(s =>
                                formData.search_site_ids?.includes(s.value)
                            )}
                            placeholder="Select Site"
                        />
                    </div>
                </div>

                {/* Asset Type Group */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Asset Type Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedAssetGroups}
                            changeEvent={handleAssetGroupChange}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedAssetGroups.filter(s =>
                                formData.asset_group_ids?.includes(s.value)
                            )}
                            placeholder="Select Asset Type Group"
                        />
                    </div>
                </div>

                {/* Asset Type */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Asset Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedAssetTypes}
                            changeEvent={(selectedOption) =>
                                tapSelectChange(selectedOption, "search_asset_type_ids")
                            }
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedAssetTypes.filter(s =>
                                formData.search_asset_type_ids?.includes(s.value)
                            )}
                            placeholder="Select Asset Type"
                        />
                    </div>
                </div>

                {/* Asset Matrix */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Asset Matrix</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedAssetMatrix}
                            changeEvent={(selectedOption) =>
                                tapSelectChange(selectedOption, "search_asset_matrix_ids")
                            }
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedAssetMatrix.filter(s =>
                                formData.search_asset_matrix_ids?.includes(s.value)
                            )}
                            placeholder="Select Asset Matrix"
                        />
                    </div>
                </div>

                {/* Manufacturer */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Manufacturer</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedManufactures}
                            changeEvent={(selectedOption) =>
                                tapSelectChange(selectedOption, "search_manufacturer_ids")
                            }
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedManufactures.filter(s =>
                                formData.search_manufacturer_ids?.includes(s.value)
                            )}
                            placeholder="Select Manufacturer"
                        />
                    </div>
                </div>

                {/* Model */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Model</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={transformedModels}
                            changeEvent={(selectedOption) =>
                                tapSelectChange(selectedOption, "search_models")
                            }
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={transformedModels.filter(s =>
                                formData.search_models?.includes(s.value)
                            )}
                            placeholder="Select Model"
                        />
                    </div>
                </div>

                {/* Asset */}
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Asset</label>
                    <div className="col-sm-6">
                        <InputAssetSearch
                            clAttribute="Y"
                            isMulti={true}
                            changeEvent={(selectedOption) => {
                                tapSelectChange(selectedOption, "search_asset_ids");
                                setSearchedAssets(selectedOption || []);
                            }}
                            value={searchedAssets && searchedAssets.length > 0
                                ? searchedAssets.map(a => {
                                    a.label = a.display_label;
                                    return a;
                                })
                                : []}
                        />
                    </div>
                </div>
                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm">Asset Category</label>
                    <div className="col-sm-6">
                        <TapSelect
                            menuPlacement='top'
                            options={asset_category}
                            changeEvent={(selectedOption) => {
                                tapSelectChange(selectedOption, 'search_asset_category');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            value={asset_category.find(r => r.value === formData.search_asset_category)}
                            placeholder="Select Asset Category"
                        />
                    </div>
                </div>

                <CommonOwnerShipCategorySearch
                    ref={ownershipRef}
                    onChange={handleOwnerCategoryChange}
                    onDataLoad={handleOwnerDataLoad}
                    value={formData}
                />

                <div className="row mb-3 align-items-center">
                    <label className="text-end col-sm-3 col-form-label col-form-label-sm require">Date Range</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={assetPerformanceFormData?.periods || []}
                            value={formData.date_range}
                            startDate={formData.date_range_start}
                            endDate={formData.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                setFormData(prev => ({
                                    ...prev,
                                    date_range: period,
                                    date_range_start: startDate,
                                    date_range_end: endDate
                                }));
                            }}
                            required={true}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={assetCostingData.loading || summaryData.loading} className="btn btn-primary px-4">
                            Show Report
                        </button>
                    </div>
                </div>
            </form>
        );
    };

    const pageTitleBarJsx = () => {
        return (
            <div className="page_title row m0">
                <div className="col-sm-12 px-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <h3>
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faChartLine} /> Asset Wise Production Costing Report
                        </h3>
                        <div className="d-flex align-items-center">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={() => toggleFilterForm(!filterShow)}
                            >
                                Change Filter
                            </button>
                            {reportSubmitted && (
                                <>
                                    
                                    <button
                                        type="button"
                                        disabled={assetCostingData.downloading || assetCostingData.loading || summaryData.loading}
                                        className="btn btn-secondary"
                                        onClick={reportDownloadHandler}
                                    >
                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                        {assetCostingData.downloading && (
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        disabled={assetCostingData.downloading || assetCostingData.loading}
                                        className="btn btn-secondary"
                                        onClick={closeReport}
                                    >
                                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close report" />
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            setCriteriaHeight(height);
        }
    }, [searchedElems]);

    const renderSummaryWidget = () => {
        const { data, loading } = summaryData;

        return (
            <div className="row bg-white" style={{
                maxHeight: "calc(100vh - 330px)",
                overflow: "auto",
            }}>
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="fw-bold primary_color">Summary </h6>
                            {loading ? (
                                <Loader />
                            ) : data ? (
                                <>
                                    <div className="table-responsive col-6">
                                        <table className="table table-bordered table-hover bg-white mt-1">
                                            <tbody>
                                                <tr>
                                                    <td>Total Production</td>
                                                    <td className="text-end fw-bold">
                                                        <CurrencyFormatter currencyCode={props.default_currency} amount={parseFloat(data.total_production || 0)} />
                                                    </td>
                                                </tr>
                                                <br/>
                                                <tr>
                                                    <td style={{ width: '30%' }}>Total Fuel Consumed</td>
                                                    <td className="text-end fw-bold" style={{ width: '20%' }}>
                                                       {data.total_fuel_consumed ? TapHelper.numberFormatter(data.total_fuel_consumed) : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: '30%' }}>Average Fuel Cost</td>
                                                    <td className="text-end fw-bold" style={{ width: '20%' }}>
                                                       {data.total_fuel_consumed > 0 ? TapHelper.dispayAsAmount(data.total_fuel_expense/data.total_fuel_consumed) : 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Fuel per Unit Production</td>
                                                    <td className="text-end fw-bold">
                                                        {data.total_production > 0 ? TapHelper.numberFormatter(data.total_fuel_consumed/data.total_production) : 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Fuel Expense per Unit Production</td>
                                                    <td className="text-end fw-bold">
                                                        {data.total_production > 0 ? TapHelper.numberFormatter(data.total_fuel_expense/data.total_production) : 0}
                                                    </td>
                                                </tr>
                                                <br/>
                                                <tr>
                                                    <td>Total Fuel Expense</td>
                                                    <td className="text-end fw-bold">
                                                        <CurrencyFormatter currencyCode={props.default_currency} amount={parseFloat(data.total_fuel_expense || 0)} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Asset Expense (Non Fuel)</td>
                                                    <td className="text-end fw-bold">
                                                        <CurrencyFormatter currencyCode={props.default_currency} amount={parseFloat(data.total_non_fuel_expense || 0)} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Item Expense</td>
                                                    <td className="text-end fw-bold">
                                                        <CurrencyFormatter
                                                            currencyCode={props.default_currency}
                                                            amount={parseFloat(data.total_item_expense || 0)}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: '30%' }}>Total Expense</td>
                                                    <td className="text-end fw-bold" style={{ width: '20%' }}>
                                                        <CurrencyFormatter currencyCode={props.default_currency} amount={parseFloat(data.total_cost_to_company || 0)} />
                                                    </td>
                                                </tr>
                                                <br/>
                                                <tr>
                                                    <td>Total Cost per Unit Production</td>
                                                    <td className="text-end fw-bold">
                                                        <CurrencyFormatter
                                                            currencyCode={props.default_currency}
                                                            amount={data.total_production > 0 ? TapHelper.dispayAsAmount(data.total_cost_to_company/data.total_production) : 0}
                                                        />
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <div className="text-center py-4">No summary data available</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderListingTable = () => (
        <>
            <div className='mb-2' style={{
                maxHeight: "calc(100vh - 330px)",
                overflow: "auto",
            }} >
                <table className="table table-sm table-bordered align-middle bg-white table-fixed">
                    <thead className="align-middle table-secondary" style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#e9ecef"
                    }}>
                        <tr className='text-center'>
                            <th style={{ width: "4%" }}>S.No</th>
                            <th style={{ width: "12%" }}>Asset Name</th>
                            <th style={{ width: "10%" }}>Asset Code</th>
                            <th style={{ width: "8%" }}>Total Production</th>
                            <th style={{ width: "8%" }}>Total Fuel</th>
                            <th style={{ width: "10%" }}>Fuel per unit Production</th>
                            <th style={{ width: "8%" }}>Fuel Expense</th>
                            <th style={{ width: "8%" }}>Asset Expense</th>
                            <th style={{ width: "8%" }}>Item Expense</th>
                            <th style={{ width: "8%" }}>Total Expense</th>
                            <th style={{ width: "10%" }}>Cost Per unit Production</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assetCostingData.loading ? (
                            <tr>
                                <td className='text-center' colSpan={12}><Loader /></td>
                            </tr>
                        ) : assetCostingData.items?.length > 0 ? (
                            assetCostingData.items.map((item, index) => {
                                const serialNo = assetCostingData.meta
                                    ? assetCostingData.meta.from + index
                                    : index + 1;

                                return (
                                    <tr key={item.asset_id || index}>
                                        <td className='text-center'>{serialNo}</td>
                                        <td className='text-center'>{item.name || '-'}</td>
                                        <td className='text-center'>{item.asset_code || '-'}</td>
                                        <td className='text-end'> {item.total_production ? TapHelper.numberFormatter(item.total_production,3) : ''}
                                        </td>
                                        <td className='text-end'>
                                            {item.total_fuel ?
                                                item.total_fuel
                                                : '-'}
                                        </td>
                                        <td className='text-end'>
                                            {item.fuel_per_unit_production ?
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.fuel_per_unit_production)}
                                                />
                                                : '-'}
                                        </td>
                                        <td className='text-end'>
                                            {item.fuel_expense ? (
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.fuel_expense)}
                                                />
                                            ) : "-"}
                                        </td>
                                        <td className='text-end'>
                                            {item.asset_expense ? (
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.asset_expense)}
                                                />
                                            ) : "-"}
                                        </td>
                                        <td className='text-end'>
                                            {item.item_expense ? (
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.item_expense)}
                                                />
                                            ) : "-"}
                                        </td>
                                        <td className='text-end'>
                                            {item.total_expense ? (
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.total_expense)}
                                                />
                                            ) : "-"}
                                        </td>
                                        
                                        <td className='text-end'>
                                            {item.cost_per_unit_production ? (
                                                <CurrencyFormatter
                                                    currencyCode={props.default_currency}
                                                    amount={parseFloat(item.cost_per_unit_production)}
                                                />
                                            ) : "-"}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className='text-center' colSpan={12}>No Record Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <DisplayListPagination
                meta={assetCostingData.meta}
                onPageChange={(e) => loadItemsData(e.selected + 1)}
            />
        </>
    );

    const reportTabs = [
        { name: 'Summary', jsx: renderSummaryWidget() },
        { name: 'Asset Wise Production Costing Report', jsx: renderListingTable() },
    ];


    return (
        <ApplicationLayout>
            <Helmet><title>Asset Wise Production Costing Report</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div className={["bg-white", filterShow ? 'tbShow' : 'tbHide'].join(" ")}>
                            {reportFilterFormJsx()}
                        </div>
                        {reportSubmitted && (
                            <>
                                {searchedElems.length > 0 && (
                                    <div ref={criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 1,
                                        }}>
                                        <DisplaySearchCriteria 
                                            searchedElems={searchedElems} 
                                        />
                                    </div>
                                )}
                                <div className="bg-white pb-4">
                                    <TapNavTabs
                                        tabReinitialize="N"
                                        tabs={reportTabs}
                                        activetab={currentTab}
                                        setTabValue={setCurrentTab}
                                        noHeaderClass={true}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
});

export default AssetWiseProductionCostingReport;